import { Text } from "@carbon6/c6-frontend-design";
import type { ReactNode } from "react";
import { hatcheryTextModes } from "@/app/theme";
import styles from "./PartImagePlaceholder.module.css";

// 부품 이미지가 없을 때 표시하는 기본 자리표시자다.
export function PartImagePlaceholder(): ReactNode {
  return (
    <div className={styles.box} role="img" aria-label="등록된 부품 이미지가 없습니다.">
      <svg className={styles.icon} viewBox="0 0 48 48" aria-hidden="true">
        <rect x="6" y="9" width="36" height="30" rx="3" fill="none" stroke="currentColor" />
        <circle cx="17" cy="19" r="3.4" fill="currentColor" />
        <path d="M9 35l10-11 7 7 6-6 7 8v3H9z" fill="currentColor" />
      </svg>
      <Text variant={hatcheryTextModes["caption-normal"]} className={styles.caption}>
        등록된 부품 이미지가 없습니다.
      </Text>
    </div>
  );
}
